import { Button, Space } from "antd";
import CourseSelection from "Components/CommonComponents/CourseSelection";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import QuizBuilderPage from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizBuilderPage";
import React from "react";
import styled from "styled-components";
const Styleddiv = styled.div<any>`
  height: calc(100vh - 125px);
  display: flex;
  overflow: auto;
`;
const QuizDrawerComponents = ({ selectedCourse }: any) => {
  const {
    isCourseLoading,
    setStepperForm,
    setIsCourseLoading,
    stepperForm,
    setIsDrawerOpen,
    setSelectedQuestions,
    setQuestions,
  } = useQuizContext();
  const step2 = stepperForm["step2"];
  const { nodeIds = [], chapterIds = [] } = step2 || {};
  const isDisabled = nodeIds?.length || chapterIds?.length;
  const selectedKeys = [...nodeIds, ...chapterIds];
  return (
    <div>
      {isCourseLoading ? (
        <>
          <Styleddiv>
            <CourseSelection
              selectedCourse={selectedCourse}
              selectedKeys={selectedKeys}
              onTreeChange={(checkedKeys: React.Key[]) => {
                setStepperForm((prevForm: any) => ({
                  ...prevForm,
                  step2: checkedKeys,
                }));
                setSelectedQuestions([]);
                setQuestions([]);
              }}
            ></CourseSelection>
          </Styleddiv>
          <Space style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                setIsDrawerOpen(false);
              }}
            >
              Back
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setIsCourseLoading(false);
              }}
              disabled={!isDisabled}
            >
              Continue
            </Button>
          </Space>
        </>
      ) : (
        <QuizBuilderPage></QuizBuilderPage>
      )}
    </div>
  );
};

export default QuizDrawerComponents;
